<template><WdsText :text /></template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'
import { JobStartTimeframe } from '@/gql/graphql'
import { startDateTimeframeOptions } from '@/components/Job/constants'

const JobStartDateColumn = graphql(`
  fragment JobStartDateColumn on Job {
    id
    startDate
    startDateTimeframe
  }
`)

const props = defineProps<{
  row: FragmentType<typeof JobStartDateColumn>
}>()
const column = computed(() => useFragment(JobStartDateColumn, props.row))

const lookupText = startDateTimeframeOptions.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  {},
)

const text = computed(() => {
  const { date, isValid } = useDate(column.value.startDate)
  if (column.value.startDateTimeframe) {
    switch (column.value.startDateTimeframe) {
      case JobStartTimeframe.OnDate:
        if (isValid.value && !!date.value) {
          return date.value
        }
        return lookupText[column.value.startDateTimeframe]
      default:
        return lookupText[column.value.startDateTimeframe]
    }
  }

  return '-'
})
</script>

<style lang="scss"></style>
